var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function PlusIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 3.99985C13 3.44495 12.5523 3 12 3C11.4439 3 11 3.44765 11 3.99985V11H3.99985C3.44495 11 3 11.4477 3 12C3 12.5561 3.44765 13 3.99985 13H11V20.0001C11 20.5551 11.4477 21 12 21C12.5561 21 13 20.5524 13 20.0001V13H20.0001C20.5551 13 21 12.5523 21 12C21 11.4439 20.5524 11 20.0001 11H13V3.99985Z", fill: "" })));
}
export var PlusIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: PlusIconInner }, props))); };
//# sourceMappingURL=PlusIcon.js.map